import React, { useEffect } from 'react';
import axios from 'axios';

const CustomerQueries = () => {
    const [customerQueries, setCustomerQueries] = React.useState([]);
    const [searchTerm,setSearchTerm] = React.useState("")
    const [date,setDate] = React.useState("")

    const fetchCustomerQueries = async (search = "",date="") => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/contactus?search=${search}&date=${date}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('admin_token')}`,
                    },
                }
            );
            setCustomerQueries(response.data.data);
        } catch (error) {
            console.error('Error fetching customer queries:', error);
        }
    };

    useEffect(() => {
        fetchCustomerQueries();
    }, []);

    useEffect(()=>{     
        const delayDebounce = setTimeout(() => {
            fetchCustomerQueries(searchTerm,date)
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchTerm,date])

    return (
        <div className="overflow-x-auto relative  sm:rounded-lg">
            <h2 className="text-2xl font-bold mb-4">Customer Queries List</h2>

            <div className='py-10 h-[700px] bg-white rounded-xl px-2' >
                 <div className="w-full flex items-center gap-5 mb-4">
                     <input
                        type="text"
                        className="border rounded-xl border-slate-700 p-2 w-[300px] px-3"
                        placeholder="search by mobile number, email"
                        value={searchTerm}
                        onChange={e => {
                            setSearchTerm(e.target.value);
                        }}
                    />
                    <input
                        type="date"
                        className="border rounded-xl border-slate-700 p-2 w-[200px] px-3"
                        placeholder="search by payment id, order id, user name"
                        value={date}
                        max={new Date().toISOString().split("T")[0]}
                        onChange={e => {
                            setDate(e.target.value);
                        }}
                    />
                   <button
                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                    onClick={() => {
                      setSearchTerm("");
                      setDate("");
                    }}
                  >
                    Clear Filters 
                  </button>
                </div>
                <table className="w-full text-sm text-left text-black">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                        <tr> 
                            <th className="py-3 px-6">S.No</th>
                            <th className="py-3 px-6">Email</th>
                            <th className="py-3 px-6">Mobile</th>
                            <th className="py-3 px-6">Query/Message</th>
                            <th className="py-3 px-6">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                    {customerQueries.length === 0 ? (
                        <tr>
                        <td colSpan={5} className="text-center py-4">
                            No queries found
                        </td>
                        </tr>
                    ) : (
                        customerQueries.map((query, idx) => (
                        <tr key={query.id} className="border-b bg-white">
                            <td className="py-3 px-6">{idx + 1}</td>
                            <td className="py-3 px-6">{query.email}</td>
                            <td className="py-3 px-6">{query.mobile_number}</td>
                            <td className="py-3 px-6">{query.message}</td>
                            <td className="py-3 px-6">
                            {new Date(query.created_at).toLocaleDateString()}
                            </td>
                        </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div >
    );
};

export default CustomerQueries;